module.exports = __webpack_public_path__ + "img/packet.aac0f30b.png";